import React, { Component } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Modal, Table } from 'react-bootstrap';
import AppSpinner from '../AppSpinner/AppSpinner';
import formatMoney from '../../utils/formatMoney';
import Select from 'react-select';
import { connect } from 'react-redux';
import { pucCodes } from '../../utils/pucCodes';
import apiUrl from '../../utils/apiUrl';
import './styles/styles.scss';

const select = state => {
  return {
    token: state.auth.token
  };
};

// const accountCategoriesLabels = {
//   'CASH_AND_BANK': 'Efectivo y bancario',
//   'MONEY_IN_TRANSIT': 'Dinero en tránsito',
//   'CREDIT_CARD': 'Tarjeta de crédito',
//   'LOAN_AND_LINE_OF_CREDIT': 'Préstamo y línea de crédito',
// };

const categoryTypesLabels = {
  'GAIN_ON_FOREIGN_EXCHANGE': 'Ganancias cambiarias',
  'INCOME': 'Ingresos',
  'SALES': 'Ventas',
  'UNCATEGORIZED_INCOME': 'Ingresos sin categoría',
  'ACCOUNTING_FEES': 'Cargos contables',
  'ADVERTISING_AND_PROMOTION': 'Publicidad y promoción',
  'BANK_SERVICE_CHARGES': 'Gastos bancarios',
  'COMPUTER_HARDWARE': 'Computadores - Hardware',
  'COMPUTER_HOSTING': 'Computadores - Hosting',
  'COMPUTER_INTERNET': 'Computadores - Internet',
  'COMPUTER_SOFTWARE': 'Computadores - Software',
  'DEPRECIATION_EXPENSE': 'Gasto de depreciación',
  'DUES_AND_SUSCRIPTIONS': 'Suscripciones',
  'EQUIPMENT_LEASE_OR_RENTAL': 'Arrendamiento o renta de equipo',
  'INSURANCE_VEHICLES': 'Seguro de vehículos',
  'INTEREST_EXPENSE': 'Gasto por intereses',
  'LOSS_ON_FOREIGN_EXCHANGE': 'Pérdidas en transacciones en divisas',
  'MEALS_AND_ENTERTAINMENT': 'Comidas y entretenimiento',
  'OFFICE_SUPPLIES': 'Suministros de oficina',
  'PAYROLL_EMPLOYEE_BENEFITS': 'Nómina - Beneficios para empleados',
  'PAYROLL_EMPLOYERS_SHARE_OF_BENEFITS': 'Nómina - Employers share of benefits',
  'PAYROLL_SALARY_AND_WAGES': 'Nómina - Sueldos y salarios',
  'POSTAGE_AND_DELIVERY': 'Correspondencia y postal',
  'PROFESSIONAL_FEES': 'Costos profesionales',
  'RENT_EXPENSE': 'Gastos de arrendamiento',
  'REPAIRS_AND_MAINTENANCE': 'Reparaciones y mantenimiento',
  'SUBCONTRACTED_SERVICES': 'Servicios subcontratados',
  'TELEPHONE_LAND_LINE': 'Teléfono - Línea telefónica',
  'TELEPHONE_WIRELESS': 'Teléfono - Inalámbrico',
  'TRAVEL_EXPENSE': 'Gasto de viaje',
  'UNCATEGORIZED_EXPENSE': 'Gasto no categorizado',
  'VEHICLE_FUEL': 'Vehículos - Combustible',
  'VEHICLE_REPAIRS_AND_MAINTENANCE': 'Vehículos - Reparaciones y mantenimiento',
  'ACCOUNTS_RECEIVABLE': 'Cuentas por cobrar',
  'ACCOUNTS_PAYABLE': 'Cuentas por pagar',
  'OWNER_INVESTMENT_DRAWINGS': 'Inversión del propietario',
  'OWNERS_EQUITY': 'Capital del propietario'
};

class ConnectedAccountingComponent extends Component {

  constructor(props) {

    super(props);

    this.state = {
      show: false,
      show2: false,
      error: false,
      editing: false,
      loading: true,
      description: '',
      date: new Date(),
      supportType: 'FACTURA_VENTA',
      supportFile: '',
      supportFileValue: '',
      supportFileChanged: false,
      account: 'EFECTIVO',
      type: 'DEPOSIT',
      amount: '',
      categoryType: 'ASSET_ACCOUNTS',
      category: '',
      notes: '',
      formValidated: false,
      creatingTransaction: false,
      transactions: [],
      transactionAccounts: [],
      accountType: 'CASH_AND_BANK',
      accountName: '',
      accountDescription: '',
      showCreateAccountModal: false,
      showCreatecategoryModal: false,
      creatingAccount: false,
      formValidatedAccount: false,
      transactionToEdit: '',
      search: '',
      subTransactions: [],
      transactionSplited: false,
      categoryTypeOptions: [
        {
          type: 'group',
          active: true,
          name: 'Cuentas de ingresos',
          category: 'INCOME_ACCOUNTS',
          items: [
            { value: 'GAIN_ON_FOREIGN_EXCHANGE', label: categoryTypesLabels['GAIN_ON_FOREIGN_EXCHANGE'] },
            { value: 'INCOME', label: categoryTypesLabels['INCOME'] },
            { value: 'SALES', label: categoryTypesLabels['SALES'] },
            { value: 'UNCATEGORIZED_INCOME', label: categoryTypesLabels['UNCATEGORIZED_INCOME'] },
          ]
        },
        {
          type: 'group',
          active: true,
          name: 'Cuentas de gastos',
          category: 'EXPENSE_ACCOUNTS',
          items: [
            { value: 'ACCOUNTING_FEES', label: categoryTypesLabels['ACCOUNTING_FEES'] },
            { value: 'ADVERTISING_AND_PROMOTION', label: categoryTypesLabels['ADVERTISING_AND_PROMOTION']  },
            { value: 'BANK_SERVICE_CHARGES', label: categoryTypesLabels['BANK_SERVICE_CHARGES'] },
            { value: 'COMPUTER_HARDWARE', label: categoryTypesLabels['COMPUTER_HARDWARE']  },
            { value: 'COMPUTER_HOSTING', label: categoryTypesLabels['COMPUTER_HOSTING'] },
            { value: 'COMPUTER_INTERNET', label: categoryTypesLabels['COMPUTER_INTERNET'] },
            { value: 'COMPUTER_SOFTWARE', label: categoryTypesLabels['COMPUTER_SOFTWARE'] },
            { value: 'DEPRECIATION_EXPENSE', label: categoryTypesLabels['DEPRECIATION_EXPENSE'] },
            { value: 'DUES_AND_SUSCRIPTIONS', label: categoryTypesLabels['DUES_AND_SUSCRIPTIONS'] },
            { value: 'EQUIPMENT_LEASE_OR_RENTAL', label: categoryTypesLabels['EQUIPMENT_LEASE_OR_RENTAL'] },
            { value: 'INSURANCE_VEHICLES', label: categoryTypesLabels['INSURANCE_VEHICLES'] },
            { value: 'INTEREST_EXPENSE', label: categoryTypesLabels['INTEREST_EXPENSE'] },
            { value: 'LOSS_ON_FOREIGN_EXCHANGE', label: categoryTypesLabels['LOSS_ON_FOREIGN_EXCHANGE'] },
            { value: 'MEALS_AND_ENTERTAINMENT', label: categoryTypesLabels['MEALS_AND_ENTERTAINMENT'] },
            { value: 'OFFICE_SUPPLIES', label: categoryTypesLabels['OFFICE_SUPPLIES'] },
            { value: 'PAYROLL_EMPLOYEE_BENEFITS', label: categoryTypesLabels['PAYROLL_EMPLOYEE_BENEFITS'] },
            { value: 'PAYROLL_EMPLOYERS_SHARE_OF_BENEFITS', label: categoryTypesLabels['PAYROLL_EMPLOYERS_SHARE_OF_BENEFITS'] },
            { value: 'PAYROLL_SALARY_AND_WAGES', label: categoryTypesLabels['PAYROLL_SALARY_AND_WAGES'] },
            { value: 'POSTAGE_AND_DELIVERY', label: categoryTypesLabels['POSTAGE_AND_DELIVERY'] },
            { value: 'PROFESSIONAL_FEES', label: categoryTypesLabels['PROFESSIONAL_FEES'] },
            { value: 'RENT_EXPENSE', label: categoryTypesLabels['RENT_EXPENSE'] },
            { value: 'REPAIRS_AND_MAINTENANCE', label: categoryTypesLabels['REPAIRS_AND_MAINTENANCE'] },
            { value: 'SUBCONTRACTED_SERVICES', label: categoryTypesLabels['SUBCONTRACTED_SERVICES'] },
            { value: 'TELEPHONE_LAND_LINE', label: categoryTypesLabels['TELEPHONE_LAND_LINE'] },
            { value: 'TELEPHONE_WIRELESS', label: categoryTypesLabels['TELEPHONE_WIRELESS'] },
            { value: 'TRAVEL_EXPENSE', label: categoryTypesLabels['TRAVEL_EXPENSE'] },
            { value: 'UNCATEGORIZED_EXPENSE', label: categoryTypesLabels['UNCATEGORIZED_EXPENSE'] },
            { value: 'VEHICLE_FUEL', label: categoryTypesLabels['VEHICLE_FUEL'] },
            { value: 'VEHICLE_REPAIRS_AND_MAINTENANCE', label: categoryTypesLabels['VEHICLE_REPAIRS_AND_MAINTENANCE'] }
          ]
        },
        {
          type: 'group',
          active: true,
          name: 'Cuentas de activos',
          category: 'ASSET_ACCOUNTS',
          items: [
            { value: 'ACCOUNTS_RECEIVABLE', label: categoryTypesLabels['ACCOUNTS_RECEIVABLE'] }
          ]
        },
        {
          type: 'group',
          active: true,
          name: 'Cuentas de pasivos',
          category: 'LIABILITY_ACCOUNTS',
          items: [
            { value: 'ACCOUNTS_PAYABLE', label: categoryTypesLabels['ACCOUNTS_PAYABLE'] }
          ]
        },
        {
          type: 'group',
          active: true,
          name: 'Cuentas de capital',
          category: 'EQUITY_ACCOUNTS',
          items: [
            { value: 'OWNER_INVESTMENT_DRAWINGS', label: categoryTypesLabels['OWNER_INVESTMENT_DRAWINGS'] },
            { value: 'OWNERS_EQUITY', label: categoryTypesLabels['OWNERS_EQUITY'] }
          ]
        }
      ]
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleCloseAccountModal = this.handleCloseAccountModal.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // this.handleSubmitAccount = this.handleSubmitAccount.bind(this);
    this.getTransactions = this.getTransactions.bind(this);
    this.splitTransaction = this.splitTransaction.bind(this);
    this.addCategory = this.addCategory.bind(this);
    this.handleSubTransactionChange = this.handleSubTransactionChange.bind(this);
    this.deleteSubTransaction = this.deleteSubTransaction.bind(this);
    this.handleDropdwonChange = this.handleDropdwonChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.triggerInputFile = this.triggerInputFile.bind(this);
  }

  handleFileChange(event) {
    if (event.target.files[0]) {
      this.setState({
        supportFile: event.target.files,
        supportFileValue: event.target.files[0].name,
        supportFileChanged: true
      });
    }
  }

  readFile(file) {
    const reader = new FileReader();

    reader.addEventListener('load', undefined);
    reader.readAsDataURL(file);
    const formData = new FormData();

    formData.append('file', file);

    return formData;
  }

  async uploadFile(fileInput) {

    let fileUrl;

    if (fileInput) {
      const formData = this.readFile(fileInput[0]);
      const uploadFile = await fetch(`${apiUrl}/files/file-upload`, {
        method: 'POST',
        body: formData
      });

      const fileJson = await uploadFile.json();
      fileUrl = fileJson.fileUrl;
    }

    return fileUrl;
  }

  triggerInputFile(input) {
    this[input].click();
  }

  handleInputChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  handleClose() {
    this.setState({
      show: false,
      description: '',
      date: new Date(),
      account: 'EFECTIVO',
      type: 'DEPOSIT',
      amount: '',
      category: '',
      supportType: 'FACTURA_VENTA',
      supportFile: '',
      supportFileValue: '',
      supportFileChanged: false,
      categoryType: 'ASSET_ACCOUNTS',
      notes: '',
      transactionSplited: false,
      subTransactions: [],
      formValidated: false
    });
  }

  handleCloseAccountModal() {
    this.setState({
      showCreateAccountModal: false,
      accountType: 'CASH_AND_BANK',
      accountName: '',
      accountDescription: '',
      creatingAccount: false,
      formValidatedAccount: false
    });
  }

  async getTransactions() {

    const { token } = this.props;
    const getTransactionsProm = await fetch(`${apiUrl}/admin/transactions/get?token=${token}`);
    const transactionsResp = await getTransactionsProm.json();

    if (transactionsResp.success) this.setState({transactions: transactionsResp.transactions});
  }

  // async getAccounts() {
  //   const {userId, token, businessType} = this.props;

  //   const getAccountsProm = await fetch(`/transactions/get/accounts?token=${token}&id=${userId}&businessType=${businessType}`);
  //   const accountsResp = await getAccountsProm.json();

  //   if(accountsResp.success) {
  //     const {data} = accountsResp;
  //     let cashAdded = false;

  //     const transactionAccounts = data.map(account => {

  //       const el = {
  //         type: 'group',
  //         category: account._id,
  //         name: accountCategoriesLabels[account._id],
  //         items: account.accounts.map(item => {
  //           return {value: item.accountName, label: item.accountName};
  //         })
  //       };

  //       if(account._id === 'CASH_AND_BANK') {
  //         cashAdded = true;
  //         el.items.push({ value: 'EFECTIVO', label: 'Efectivo' });
  //       }
        
  //       return el;
          
  //     });

  //     if(!cashAdded) {
  //       transactionAccounts.push({
  //         type: 'group',
  //         name: 'Efectivo y bancario',
  //         category: 'CASH_AND_BANK',
  //         items: [
  //           { value: 'EFECTIVO', label: 'Efectivo' }
  //         ]
  //       });
  //     }

  //     transactionAccounts.push({
  //       type: 'group',
  //       name: 'Contribución o inversión del propietario',
  //       category: 'BUSINESS_OWNER_CONTRIBUTION_AND_DRAWING',
  //       items: [
  //         { value: 'INVERSION_PROPIETARIO', label: 'Inversión del propietario' }
  //       ]
  //     });

  //     this.setState({transactionAccounts});

  //   } else {
  //     this.setState({transactionAccounts: [
  //       {
  //         type: 'group',
  //         name: 'Efectivo y bancario',
  //         category: 'CASH_AND_BANK',
  //         items: [
  //           { value: 'EFECTIVO', label: 'Efectivo' }
  //         ]
  //       }, {
  //         type: 'group',
  //         name: 'Contribución o inversión del propietario',
  //         category: 'BUSINESS_OWNER_CONTRIBUTION_AND_DRAWING',
  //         items: [
  //           { value: 'INVERSION_PROPIETARIO', label: 'Inversión del propietario' }
  //         ]
  //       }
  //     ]});
  //   }
  // }

  // async getCategories() {
  //   const {userId, token, businessType} = this.props;

  //   const getCategoriesProm = await fetch(`/transactions/get/categories?token=${token}&id=${userId}&businessType=${businessType}`);
  //   const categoriesResp = await getCategoriesProm.json();

  //   if(categoriesResp.success) {
  //     const {data} = categoriesResp;
  //     const categoriesArray = [...this.state.categoryTypeOptions];

  //     data.forEach(item => {
  //       const category = categoriesArray.find(cat => cat.category === item._id);

  //       if(category) {
  //         category.items = category.items.concat(item.categories.map(cat => { 
  //           return { value: cat.categoryName, label: cat.categoryName };
  //         }));
  //       }

  //     });

  //     this.setState({categoryTypeOptions: categoriesArray});
  //   }
  // }

  async componentDidMount() {
    const transactionProm = this.getTransactions();
    // const accountProm = this.getAccounts();
    // const categoriesProm = this.getCategories();

    await transactionProm;
    // await accountProm;
    // await categoriesProm;
    
    this.setState({ loading: false });
  }

  // async handleSubmitAccount(event) {
  //   event.preventDefault();
  //   event.stopPropagation();

  //   this.setState({formValidatedAccount: true, creatingAccount: true});

  //   const form = event.currentTarget;
  //   const {
  //     accountType,
  //     accountName,
  //     accountDescription
  //   } = this.state;

  //   if(form.checkValidity()) {
      
  //     const {userId, token, businessType} = this.props;

  //     const createAccountProm = await fetch(`/transactions/create/account?token=${token}&id=${userId}`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify({
  //         description: accountDescription,
  //         accountType,
  //         accountName,
  //         businessType
  //       })
  //     });

  //     const resp = await createAccountProm.json();

  //     if(resp.success) {
        
  //       let added = false;
  //       const updatedAccounts = this.state.transactionAccounts.map(account => {

  //         if(accountType === account.category) {
  //           added = true;

  //           return {
  //             ...account,
  //             items: account.items.concat({value: accountName, label: accountName})
  //           }
  //         } else {
  //           return account
  //         }

  //       });

  //       if(!added) {
  //         updatedAccounts.push({
  //           type: 'group',
  //           name: accountCategoriesLabels[accountType],
  //           category: accountType,
  //           items: [
  //             { value: accountName, label: accountName }
  //           ]
  //         });
  //       }

  //       this.setState({transactionAccounts: updatedAccounts, account: accountName});

  //     }

  //     this.handleCloseAccountModal();
  //   }

  //   this.setState({creatingAccount: false});
  // }

  async editTransaction(index) {

    const currentTransaction = this.state.transactions[index];

    this.setState({
      description: currentTransaction.description,
      account: currentTransaction.account,
      date: `${currentTransaction.date}`.split('T')[0],
      type: currentTransaction.type,
      amount: currentTransaction.amount,
      category: currentTransaction.category,
      categoryType: currentTransaction.categoryType,
      notes: currentTransaction.notes || '',
      supportFileValue: currentTransaction.supportFile,
      supportFileChanged: false,
      supportType: currentTransaction.supportType,
      subTransactions: currentTransaction.subTransactions || [],
      transactionSplited: currentTransaction.subTransactions && currentTransaction.subTransactions.length > 0,
      editing: true,
      show: true,
      transactionToEdit: currentTransaction._id
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ formValidated: true, creatingTransaction: true });

    const form = event.currentTarget;
    const {
      description,
      amount,
      notes,
      date,
      type,
      category,
      editing,
      transactionToEdit,
      transactionSplited,
      subTransactions,
      supportFile,
      supportFileValue,
      supportFileChanged,
      supportType
    } = this.state;

    let validCategories = subTransactions.length > 0 ? true : category && category.value;
    subTransactions.forEach(item => {
      validCategories = validCategories && item.category && item.category.value; 
    });

    if (form.checkValidity() && validCategories && supportFileValue) {
      
      const { token } = this.props;
      let fileUrl;

      if (supportFileChanged) fileUrl = await this.uploadFile(supportFile);

      const createTransactionProm = await fetch(`${apiUrl}/admin/transactions/create?token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          description,
          date,
          type,
          amount,
          category,
          notes,
          editing,
          transactionToEdit,
          transactionSplited,
          subTransactions,
          supportType,
          supportFile: fileUrl
        })
      });

      const resp = await createTransactionProm.json();

      if (resp.success) await this.getTransactions();
      else this.setState({ error: true });

      this.handleClose();
      this.setState({ show2: true });
    }

    this.setState({ creatingTransaction: false });
  }

  addCategory(name, categoryType) {

    const updatedCategories = this.state.categoryTypeOptions.map(cat => {

      if(categoryType === cat.category) {

        return {
          ...cat,
          items: cat.items.concat({value: name, label: name})
        };

      } else {
        return cat;
      }

    });

    this.setState({ categoryTypeOptions: updatedCategories, category: name, categoryType });

  }

  splitTransaction(event) {
    event.preventDefault();
    event.stopPropagation();

    const { subTransactions, category, amount } = this.state;

    if (subTransactions.length === 0) {
      this.setState({
        transactionSplited: true,
        subTransactions: subTransactions.concat({
          category: category,
          amount: amount
        }).concat({
          category: '',
          amount: ''
        })
      });
    } else {
      this.setState({
        transactionSplited: true,
        subTransactions: subTransactions.concat({
          category: '',
          amount: ''
        })
      });
    }

  }

  handleSubTransactionChange(index, option, amount) {

    const subTransactions = [...this.state.subTransactions];
    const obj = subTransactions[index];

    if (option) obj.category = option;
    if (amount !== undefined) obj.amount = amount;

    this.setState({ subTransactions });
  }

  deleteSubTransaction(index) {
    const subTransactions = this.state.subTransactions.filter((item, i) => i !== index);

    if (subTransactions.length === 1) {
      this.setState({
        subTransactions: [],
        category: subTransactions[0].category,
        amount: subTransactions[0].amount,
        transactionSplited: false
      });
    }
    else {
      this.setState({ subTransactions });
    }

  }

  handleDropdwonChange(option) {

    const { categoryTypeOptions } = this.state;
    const categoryType = categoryTypeOptions.find(item => item.items.find(element => element.value === option.value));

    this.setState({ category: option.value, categoryType: categoryType.category });
  }

  render() {

    // const {businessType} = this.props;
    const {
      transactions,
      show,
      description,
      // account,
      // transactionAccounts,
      amount,
      category,
      type,
      notes,
      date,
      formValidated,
      creatingTransaction,
      show2,
      error,
      loading,
      editing,
      // accountDescription,
      // accountName,
      // accountType,
      // showCreateAccountModal,
      // creatingAccount,
      // formValidatedAccount,
      // showCreatecategoryModal,
      // categoryTypeOptions,
      transactionSplited,
      subTransactions,
      search,
      supportType,
      supportFileValue,
      supportFile,
      supportFileChanged
    } = this.state;
    let supportFileDisplayedName;

    if (supportFileValue) {
      const fileNameArr = supportFileValue.split('com/');
      const fileName = fileNameArr.length > 1 ? fileNameArr[1] : fileNameArr[0];
      supportFileDisplayedName = fileName.length > 25 ? `${fileName.substring(0, 25)}...` : fileName;
    }

    if (loading) return (<AppSpinner />);

    // const filter = type == 'DEPOSIT' ? 'EXPENSE_ACCOUNTS' : 'INCOME_ACCOUNTS';
    // const filteredCategoryOptions = categoryTypeOptions.filter(option => option.category !== filter);

    const filteredTransactions = search ?
      transactions.filter(item => {
        const cat = item.category.label;

        return cat.toLowerCase().includes(search.toLowerCase()) ||
        item.description.toLowerCase().includes(search.toLowerCase());
      }) :
      transactions;

    return (
      <div className="accounting-component">
        <Container>
          <Row>
            <Col xs={12}>
              <h1>Contabilidad</h1>
              <hr />

              <Row className="accounting-filters">
                <div className="accounting-btns col-12">
                  <Button className="nibi-btn" onClick={() => this.setState({show: true, editing: false})}>
                    Crear transacción
                  </Button>
                </div>

                <Col xs={12}>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name="search"
                      value={search}
                      onChange={this.handleInputChange}
                      placeholder="Buscar por descripción o cuenta"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Table bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Fecha</th>
                    <th>Descripción</th>
                    <th>Valor</th>
                    <th>Cuenta</th>
                  </tr>
                </thead>
                
                <tbody>
                  {
                    filteredTransactions.map((transaction, index) =>
                      <tr
                        key={transaction._id}
                        className="accounting-table-row"
                        onClick={() => this.editTransaction(index)}
                      >
                        <td>{index + 1}</td>
                        <td>{`${transaction.date}`.split('T')[0]}</td>
                        <td>{transaction.description}</td>
                        <td className={transaction.type === 'DEPOSIT' ? 'accounting-deposit' : 'accounting-withdrawal'}>
                          ${formatMoney(transaction.amount)}
                        </td>
                        <td>{transaction.category.label}</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </Col>
          </Row>

          <Modal show={show} onHide={this.handleClose} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>{!editing ? 'Crear' : 'Editar'} transacción</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Form noValidate validated={formValidated} onSubmit={this.handleSubmit}>
                <Form.Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Descripción</Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={description}
                      onChange={this.handleInputChange}
                      required
                    />
                  </Form.Group>

                  <Col xs={12}>
                    <Button className="nibi-btn accounting-split-transaction-btn" onClick={this.splitTransaction}>
                      Dividir transacción
                    </Button>
                  </Col>

                  {
                    !transactionSplited &&
                    <Form.Group as={Col} xs={12}>
                      <Form.Label className="accounting-label">
                        Categoría
                        {/* <span onClick={() => this.setState({showCreatecategoryModal: true})}>
                          Agregar cuenta
                        </span> */}
                      </Form.Label>
                      <Select
                        placeholder="Busca por nombre o código"
                        onChange={option => this.setState({ category: option })}
                        options={pucCodes}
                        value={category}
                        isMulti={false}
                        noOptionsMessage={
                          obj => !obj.inputValue || obj.inputValue.length < 3 ?
                          'Introduce por lo menos 3 caracteres' : 'No se encontraron opciones'
                        }
                        filterOption={
                          (obj, string) => {
                            if(!string || string.length < 3) return false;
                            return obj.label.toLowerCase().includes(string.toLowerCase());
                          }
                        }
                      />
                      {
                        formValidated && (!category || !category.value) &&
                        <Form.Text className="text-muted">Escoge una categoría</Form.Text>
                      }
                      {/* <Dropdown
                        options={filteredCategoryOptions}
                        onChange={this.handleDropdwonChange}
                        value={category}
                      /> */}
                    </Form.Group>
                  }

                  {
                    subTransactions.map((transaction, index) =>
                      <React.Fragment key={index}>
                        <Form.Group as={Col} xs={7}>
                          <Form.Label className="accounting-label">
                            Categoría
                            {
                              // index === 0 &&
                              // <span onClick={() => this.setState({showCreatecategoryModal: true})}>
                              //   Agregar cuenta
                              // </span>
                            }
                          </Form.Label>
                          <Select
                            placeholder="Busca por nombre o código"
                            onChange={option => this.handleSubTransactionChange(index, option)}
                            options={pucCodes}
                            value={transaction.category}
                            isMulti={false}
                            noOptionsMessage={
                              obj => !obj.inputValue || obj.inputValue.length < 3 ? 'Introduce por lo menos 3 caracteres' : 'No se encontraron opciones'
                            }
                            filterOption={
                              (obj, string) => {
                                if(!string || string.length < 3) return false;
                                return obj.label.toLowerCase().includes(string.toLowerCase());
                              }
                            }
                          />
                          {
                            formValidated && (!transaction.category || !transaction.category.value) &&
                            <Form.Text className="text-muted">Selecciona una categoría</Form.Text>
                          }
                          {/* <Dropdown
                            options={filteredCategoryOptions}
                            onChange={option => this.handleSubTransactionChange(index, option)}
                            value={transaction.category}
                          /> */}
                        </Form.Group>
                        <Form.Group as={Col} xs={4}>
                          <Form.Label className="accounting-label">
                            Monto
                          </Form.Label>
                          <Form.Control
                            type="number"
                            value={transaction.amount}
                            onChange={event => this.handleSubTransactionChange(index, undefined, event.target.value)}
                            required
                          />
                        </Form.Group>
                        <Col xs={1} className="accounting-delete-icon">
                          <i className="fas fa-trash-alt" onClick={() => this.deleteSubTransaction(index)} />
                        </Col>
                      </React.Fragment>  
                    )
                  }

                  {/* <Form.Group as={Col} xs={6}>
                    <Form.Label className="accounting-label">
                      Cuenta
                      <span onClick={() => this.setState({showCreateAccountModal: true})}>
                        Agregar cuenta
                      </span>
                    </Form.Label>
                    <Dropdown
                      options={transactionAccounts}
                      onChange={option => this.setState({account: option.value})}
                      value={account}
                    />
                  </Form.Group> */}

                  <Form.Group as={Col} xs={6}>
                    <Form.Label>Fecha</Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={date}
                      onChange={this.handleInputChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={6}>
                    <Form.Label>Tipo</Form.Label>
                    <Form.Control
                      type="text"
                      as="select"
                      name="type"
                      value={type}
                      onChange={this.handleInputChange}
                    >
                      <option value="DEPOSIT">Depósito</option>
                      <option value="WITHDRAWAL">Desembolso</option>
                    </Form.Control>
                  </Form.Group>

                  <Form.Group as={Col} xs={6}>
                    <Form.Label>Monto total</Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={!transactionSplited ? amount : ''}
                      onChange={this.handleInputChange}
                      disabled={transactionSplited}
                      required={!transactionSplited}
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={6}>
                    <Form.Label>Tipo de soporte</Form.Label>
                    <Form.Control
                      type="text"
                      as="select"
                      name="supportType"
                      value={supportType}
                      onChange={this.handleInputChange}
                    >
                      <option value="FACTURA_VENTA">Factura de venta</option>
                      <option value="FACTURA_PROVEEDOR">Factura proveedor</option>
                      <option value="RECIBO_PAGO_PROVEEDOR">Recibo de pago proveedor</option>
                      <option value="RECIBO_PAGO_FACTURA_VENTA">Recibo de pago factura de venta</option>
                      <option value="NOTA_CONTABLE">Nota contable</option>
                    </Form.Control>
                  </Form.Group>

                  <Form.Group as={Col} xs={6}>
                    <Form.Label className="accounting-label">
                      Soporte
                      {/* <span>
                        <a href="https://www.nibi.com.co/financiero/formatos" target="_blank" rel="noopener noreferrer">
                          Ver formatos de soporte de ejemplo
                        </a>
                      </span> */}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      ref={fileInput => this.supportFile = fileInput}
                      files={supportFile}
                      onChange={this.handleFileChange}
                      hidden
                    />
                    <div className="form-custom-file-input">
                      <Button onClick={() => this.triggerInputFile('supportFile')}>
                        Selecciona un archivo
                      </Button>
                      <span style={{marginLeft: '5px'}}>
                        {
                          supportFileValue ? (supportFileChanged ? supportFileDisplayedName :
                          <a href={supportFileValue} target="_blank" rel="noopener noreferrer">{supportFileDisplayedName}</a>) :
                          'No hay archivos seleccionados'
                        }
                      </span>
                    </div>
                    {
                      formValidated && !supportFileValue &&
                      <Form.Text className="text-muted">Selecciona un archivo</Form.Text>
                    }
                  </Form.Group>
                  <Form.Group as={Col} xs={6}>
                    <Form.Text className="text-muted">
                      ¿No tienes formato de soporte? Puedes ver nuestros formatos de ejemplo:
                    </Form.Text>
                    <Form.Control
                      type="text"
                      as="select"
                      onChange={event => {
                        if(event.target.value) window.open(event.target.value);
                      }}
                    >
                      <option value=""> - </option>
                      <option value="https://nibi-images.s3.us-east-2.amazonaws.com/FormatoFacturaVenta.xlsx">
                        Factura de venta
                      </option>
                      <option value="https://nibi-images.s3.us-east-2.amazonaws.com/FormatoFacturaProveedor.xlsx">
                        Factura proveedor
                      </option>
                      <option value="https://nibi-images.s3.us-east-2.amazonaws.com/FormatoReciboPagoProveedor.xlsx">
                        Recibo de pago proveedor
                      </option>
                      <option value="https://nibi-images.s3.us-east-2.amazonaws.com/FormatoReciboPagoFactVta.xlsx">
                        Recibo de pago factura de venta
                      </option>
                      <option value="https://nibi-images.s3.us-east-2.amazonaws.com/FormatoNotaContable.xlsx">
                        Nota contable
                      </option>
                    </Form.Control>
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Notas</Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      name="notes"
                      value={notes}
                      onChange={this.handleInputChange}
                    />
                  </Form.Group>
                </Form.Row>

                <Button className="nibi-btn create-transaction-button" type="submit">
                  {
                    creatingTransaction ? <Spinner size="sm" animation="border" variant="warning" /> :
                    !editing ? 'Crear' : 'Editar'
                  }
                </Button>

              </Form>
            </Modal.Body>
          </Modal>

          <Modal show={show2} onHide={() => this.setState({error: false, show2: false})} >
            <Modal.Header closeButton>
              <Modal.Title>Resultado transacción</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {
                error ? 'Ocurrió un error al crear la transacción, por favor inténtalo de nuevo.' :
                'Transacción creada satisfactoriamente.'
              }
            </Modal.Body>

            <Modal.Footer>
              <Button variant="primary" onClick={() => this.setState({error: false, show2: false})}>
                Aceptar
              </Button>
            </Modal.Footer>
          </Modal>

          {/* <Modal show={showCreateAccountModal} onHide={this.handleCloseAccountModal}>
            <Modal.Header closeButton>
              <Modal.Title>Crear cuenta</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Form noValidate validated={formValidatedAccount} onSubmit={this.handleSubmitAccount}>
                <Form.Row>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Tipo de cuenta</Form.Label>
                    <Form.Control
                      type="text"
                      name="accountType"
                      value={accountType}
                      as="select"
                      onChange={this.handleInputChange}
                      required
                    >
                      <option value="CASH_AND_BANK">Efectivo y bancario</option>
                      <option value="MONEY_IN_TRANSIT">Dinero en tránsito</option>
                      <option value="CREDIT_CARD">Tarjeta de crédito</option>
                      <option value="LOAN_AND_LINE_OF_CREDIT">Préstamo y línea de crédito</option>
                    </Form.Control>
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Nombre de la cuenta</Form.Label>
                    <Form.Control
                      type="text"
                      name="accountName"
                      value={accountName}
                      onChange={this.handleInputChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Descripción:</Form.Label>
                    <Form.Control
                      type="text"
                      name="accountDescription"
                      value={accountDescription}
                      onChange={this.handleInputChange}
                      required
                    />
                  </Form.Group>

                </Form.Row>

                <button className="nibi-btn create-transaction-button" type="submit">
                  {
                    creatingAccount ? <Spinner size="sm" animation="border" variant="warning" /> :
                    'Crear'
                  }
                </button>
              </Form>

            </Modal.Body>
          </Modal> */}

        </Container>

        {/* <AccountingCategoriesComponent
          showModal={showCreatecategoryModal}
          businessType={businessType}
          handleClose={() => this.setState({showCreatecategoryModal: false})}
          addCategory={this.addCategory}
          categoryKind={type}
        /> */}
      </div>
    );
  }

}

const AccountingComponent = connect(select)(ConnectedAccountingComponent);

export default AccountingComponent;
